import type { MetadataItem } from '../../tool-config-types';

const MAX_DESCRIPTION_LENGTH = 80;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function readString(record: Record<string, unknown>, key: string): string {
  const value = record[key];

  return typeof value === 'string' ? value.trim() : '';
}

function truncate(text: string, maxLength: number): string {
  return text.length > maxLength ? `${text.slice(0, maxLength - 1)}…` : text;
}

export const extractTerminalMetadata = ({
  input,
}: {
  input: unknown;
}): MetadataItem[] => {
  if (!isRecord(input)) {
    return [];
  }

  const description = readString(input, 'description');
  const jobId = readString(input, 'jobId');
  const action = readString(input, 'action');

  return [
    ...(description
      ? [{ value: truncate(description, MAX_DESCRIPTION_LENGTH) }]
      : []),
    ...(jobId ? [{ label: 'Job', value: jobId }] : []),
    ...(action ? [{ label: 'Action', value: action }] : []),
  ];
};
